import { CheckoutStreetAddressDto } from '@ViewModels/CheckoutStreetAddressDto'

export const formatAddress = (address: CheckoutStreetAddressDto) => {
   return [
      address.AddressLine1,
      address.AddressLine2,
      address.AddressLine3,
      address.City,
      address.Region,
      address.Postcode,
   ]
      .filter(i => i.length > 0)
      .join(', ')
}

export const addressesDoNotMatch = (
   typedInAddress: string,
   address: CheckoutStreetAddressDto
): boolean => {
   const addressFirstLine = address.AddressLine1
   if (typedInAddress.indexOf(',') > -1) {
      typedInAddress = typedInAddress.substring(0, typedInAddress.indexOf(','))
   }

   return !addressesMatch(addressFirstLine, typedInAddress)
}

const addressesMatch = (a: string, b: string) => {
   const aTokens = a
      .split(' ')
      .join('')
      .toLowerCase()
   const bTokens = b
      .split(' ')
      .join('')
      .toLowerCase()

   return aTokens.indexOf(bTokens) > -1
}
